An array of human readable descriptions of the attachment.

Resumes & cover letters can be programmatically identified using the `seekRoleCode` field.
